<template>
	<div class="flex-grow-1">
		<v-text-field 
		:label="label" 
		prepend-inner-icon="mdi-magnify"
		v-model="location_text"
		outlined
		background-color="#FFF" 
		hide-details
		ref="autocomplete"
		placeholder="" 
		:error="error"
		:error-messages="errorMessages"
		></v-text-field>
		<v-responsive :aspect-ratio="16/9">
			<div ref="map" style="width: 100%; height: 100%"></div>
		</v-responsive>
	</div>
</template>

<script>
	
	import _ from 'lodash';
	import { COUNTRY_CODE, COUNTRY_BOUNDS, MAP_CENTER, DEFAULT_LOCATION } from '@/config'
	
	export default {
		props: [
			'label',
			'value',
			'error',
			'errorMessages',
		],
		data: () => ({
			autocomplete: null,
			drawingManager: null,
			map: null,
			rect: null,
		}),

		mounted: function() {

	        this.$google.then((google) => {

	    		let input = this.$refs.autocomplete.$el.querySelector('input');
	    		let options = {
	    			bounds: {
	    				...COUNTRY_BOUNDS
	    			},
	    			componentRestrictions: {
	    				country: [COUNTRY_CODE]
	    			},
	    			types: ['geocode'],
	    			fields: ['geometry','place_id','formatted_address','address_components'],
	                strictBounds: true,
	    		};

	    		let map_options = {
					zoom: 6,
					center: MAP_CENTER,
					zoomControl: true,
					mapTypeControl: true,
					scaleControl: true,
					streetViewControl: false,
					rotateControl: false,
					fullscreenControl: false,
					disableDefaultUi: false,
		        };

		        // _.get(this.value, 'formatted_address');

	            this.autocomplete = new google.maps.places.Autocomplete(input, options);

	            this.autocomplete.addListener('place_changed', () => {
	                this.onPlaceChanged(this.autocomplete.getPlace());
	            });


	            // Setup map
	            let element = this.$refs.map;
				this.map = new google.maps.Map(element, map_options);
				// this.autocomplete.bindTo('bounds', this.map);


	            // Setting options for the Drawing Tool. In our case, enabling Polygon shape.
	            this.drawingManager = new google.maps.drawing.DrawingManager();

				this.drawingManager.setOptions({
					drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
					drawingControl: true,
					drawingControlOptions: {
						position: google.maps.ControlPosition.TOP_RIGHT,
						drawingModes: [
							google.maps.drawing.OverlayType.RECTANGLE
						]
					},
					rectangleOptions: {
						strokeColor: '#f4645f',
						strokeWeight: 2,
						fillColor: '#f4645f',
						fillOpacity: 0.3,
		                editable: true,
		              	draggable: true
					}	
				});

				// this.drawingManager.setMap(this.map);

				if (this.value) {
					let place = this.value;
					if (place.geometry) {
						this.map.fitBounds(place.geometry.viewport);
					} 
				}

	        });
		},

		methods: {
			
	        onPlaceChanged: function(response)
	        {
	            let location = {
	                ...response.geometry.location.toJSON(),
	                ...response.geometry.viewport.toJSON(),
	                formatted_address: response.formatted_address,
	                place_id: response.place_id,
	                zoom: this.calculateZoom(response)
	            }
				
	            // this.drawRect(response.geometry.viewport.toJSON());

				this.map.fitBounds(response.geometry.viewport.toJSON());

	            this.$emit('input', location);
	        },

	      	calculateZoom: function(response) 
	        {
	            let globe_width = 256; // a constant in Google's map projection
	            let pixel_width = 256;
	            let {east, west} = response.geometry.viewport.toJSON();
	            let angle = east - west;
	            if (angle < 0) angle += 360;
	            // let zoom = Math.round(Math.log(pixel_width * 360 / angle / globe_width) / Math.LN2);
	            let zoom = Math.ceil(Math.log(pixel_width * 360 / angle / globe_width) / Math.LN2);
	            return Math.min(zoom, 21);
	        },

			drawRect: function(bounds) {
				if (this.rect) {
					this.rect.setMap(null);
				}
				var rectangle = new google.maps.Rectangle({
					strokeColor: '#f4645f',
					fillColor: '#f4645f',
					strokeOpacity: 0.7,
					strokeWeight: 1,
					fillOpacity: 0.05,
					map: this.map,
					bounds: bounds
		        });

		        this.rect = rectangle;
			},	        

		},
		computed: {
			location_text: {
	    		get: function () {
	    			let v = _.get(this.value, 'formatted_address');
	    			return v;
	    		},
	    		set: function (v) {
	    			return;
	    		}
		    },
		}
	}
</script>